import _ from 'lodash';

export function getTopmostTableCellElement(target): HTMLElement {
   while (target) {
      if (target.parentElement?.localName.toLowerCase() === 'tr') {
         return target;
      }
      target = target.parentElement;
   }
   return null;
}

export function isTargetingGridHeader(event: MouseEvent): boolean {
   // Kendo offers no way to detect (double) clicks on grid headers properly
   // check for parent nodes of event target instead - there will be a TH node for headers
   let i = 0;
   const path = event?.composedPath();
   while (i < path?.length) {
      const currentNode: any = path[i++];
      if (currentNode?.nodeName === 'TH') {
         return true;
      }
   }

   return false;
}
